import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Flex, Button } from '@simplybusiness/mobius-simplybusiness';

import Header from './Header';
import ErnAvailableQuestion from './ErnAvailableQuestion';
import ErnInput from './ErnInput';
import ExemptionReasonInput from './ExemptionReasonInput';

const ErnResponseForm = ({ policyNumber }) => {
  const { watch, formState } = useFormContext();
  const showErnInput = watch('customerHaveErn', true);

  return (
    <Flex flexDirection="column" maxWidth={626}>
      <Header policyNumber={policyNumber} />
      <ErnAvailableQuestion />

      {showErnInput
            && <ErnInput />}
      {!showErnInput
            && <ExemptionReasonInput />}

      <Button loading={formState.isSubmitting} width={117} marginTop="size-70" type="submit">
        Submit
      </Button>
    </Flex>
  );
};

export default ErnResponseForm;
